export const PAYMENT_METHOD_SELECTED = 'PAYMENT_METHOD_SELECTED'
export const PLACE_ORDER_BUTTON_CLICKED = 'PLACE_ORDER_BUTTON_CLICKED'

export const paymentMethodSelected = (option: string) => ({type: PAYMENT_METHOD_SELECTED, payload: {option}})

export const placeOrderButtonClicked = () => ({type: PLACE_ORDER_BUTTON_CLICKED})
